import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import TopUpRequestTable from '../../../components/tables/TopUpRequestTable';

const formatDate = (date) => date.toISOString().split('T')[0];

const parseDate = (value) => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const retailerTopUpRequests = [
  {
    id: 'RTR0001',
    userName: 'Ajay Retail Hub',
    date: '2025-10-29',
    amount: 18000,
    mode: 'UPI',
    orderId: 'SRT123001',
    utr: 'RTRUTR783411',
    bank: 'HDFC Bank',
    transDate: '2025-10-29',
    remark: 'Weekly float replenishment',
    reason: '',
    parentId: { mobile: '9898123456' },
    userId: { mobile: '9820001122' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '09:45 AM',
  },
  {
    id: 'RTR0002',
    userName: 'BrightPay Services',
    date: '2025-10-28',
    amount: 26500,
    mode: 'NEFT',
    orderId: 'SRT123002',
    utr: 'RTRUTR783412',
    bank: 'Axis Bank',
    transDate: '2025-10-27',
    remark: 'Festival spike',
    reason: '',
    parentId: { mobile: '9977665544' },
    userId: { mobile: '9812233445' },
    status: 'Approved',
    approvedBy: 'Distributor-01',
    approvedDate: '2025-10-28',
    recorn: 'Yes',
    time: '04:20 PM',
  },
  {
    id: 'RTR0003',
    userName: 'QuickServe Retailer',
    date: '2025-10-26',
    amount: 9500,
    mode: 'IMPS',
    orderId: 'SRT123003',
    utr: 'RTRUTR783413',
    bank: 'ICICI Bank',
    transDate: '2025-10-26',
    remark: 'AEPS settlements',
    reason: 'Mismatch in reference details',
    parentId: { mobile: '9944332211' },
    userId: { mobile: '9833445566' },
    status: 'Rejected',
    approvedBy: 'Distributor-02',
    approvedDate: '2025-10-27',
    recorn: 'No',
    time: '12:35 PM',
  },
  {
    id: 'RTR0004',
    userName: 'Metro Express Retail',
    date: '2025-10-24',
    amount: 32200,
    mode: 'RTGS',
    orderId: 'SRT123004',
    utr: 'RTRUTR783414',
    bank: 'State Bank of India',
    transDate: '2025-10-24',
    remark: 'Bulk recharge demand',
    reason: '',
    parentId: { mobile: '9887766554' },
    userId: { mobile: '9899112233' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Awaiting',
    time: '06:15 PM',
  },
  {
    id: 'RTR0005',
    userName: 'Sunrise Kiosk',
    date: '2025-10-22',
    amount: 14500,
    mode: 'Cash Deposit',
    orderId: 'SRT123005',
    utr: 'RTRUTR783415',
    bank: 'Bank of Baroda',
    transDate: '2025-10-21',
    remark: 'Counter cash addition',
    reason: '',
    parentId: { mobile: '9877001122' },
    userId: { mobile: '9811003344' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Verification',
    time: '02:05 PM',
  },
  {
    id: 'RTR0006',
    userName: 'TapTop Retail',
    date: '2025-10-20',
    amount: 20400,
    mode: 'UPI',
    orderId: 'SRT123006',
    utr: 'RTRUTR783416',
    bank: 'Yes Bank',
    transDate: '2025-10-20',
    remark: 'Wallet replenishment',
    reason: '',
    parentId: { mobile: '9866554433' },
    userId: { mobile: '9844556677' },
    status: 'Approved',
    approvedBy: 'Distributor-03',
    approvedDate: '2025-10-20',
    recorn: 'Yes',
    time: '11:10 AM',
  },
  {
    id: 'RTR0007',
    userName: 'ConnectPay Booth',
    date: '2025-10-18',
    amount: 8700,
    mode: 'IMPS',
    orderId: 'SRT123007',
    utr: 'RTRUTR783417',
    bank: 'IDFC First Bank',
    transDate: '2025-10-18',
    remark: 'Unexpected payouts',
    reason: '',
    parentId: { mobile: '9855443322' },
    userId: { mobile: '9877889900' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'N/A',
    time: '03:50 PM',
  },
  {
    id: 'RTR0008',
    userName: 'PaySwift Corner',
    date: '2025-10-17',
    amount: 39600,
    mode: 'NEFT',
    orderId: 'SRT123008',
    utr: 'RTRUTR783418',
    bank: 'Kotak Mahindra Bank',
    transDate: '2025-10-16',
    remark: 'Monthly target top-up',
    reason: 'Bank proof pending',
    parentId: { mobile: '9844002211' },
    userId: { mobile: '9866110099' },
    status: 'Pending',
    approvedBy: '-',
    approvedDate: '-',
    recorn: 'Follow-up',
    time: '05:25 PM',
  },
];

const identifyDateRange = (records = []) => records.reduce(
  (range, record) => {
    const requestDate = parseDate(record?.date) || parseDate(record?.transDate);

    if (!requestDate) {
      return range;
    }

    const next = { ...range };

    if (!next.min || requestDate < next.min) {
      next.min = requestDate;
    }

    if (!next.max || requestDate > next.max) {
      next.max = requestDate;
    }

    return next;
  },
  { min: null, max: null }
);

const createDefaultFilters = (records) => {
  const range = identifyDateRange(records);
  const today = formatDate(new Date());

  return {
    fromDate: range.min ? formatDate(range.min) : today,
    toDate: range.max ? formatDate(range.max) : today,
    searchValue: '',
    pageNumber: 0,
    pageSize: 10,
  };
};

const TopUpRequestFromRetailer = () => {
  const defaultFilters = useMemo(() => createDefaultFilters(retailerTopUpRequests), []);

  const [filters, setFilters] = useState(defaultFilters);
  const [allRequests, setAllRequests] = useState(retailerTopUpRequests);
  const [requestsData, setRequestsData] = useState([]);
  const [meta, setMeta] = useState({
    totalRecords: 0,
    totalPages: 0,
    currentPage: 0,
    pageSize: defaultFilters.pageSize,
  });

  useEffect(() => {
    const from = parseDate(filters.fromDate);
    const to = parseDate(filters.toDate);
    const normalizedSearch = filters.searchValue?.trim().toLowerCase() ?? '';

    const filterByDate = (request) => {
      const requestDate = parseDate(request?.date) || parseDate(request?.transDate);

      if (!from && !to) {
        return true;
      }

      if (!requestDate) {
        return false;
      }

      if (from && requestDate < from) {
        return false;
      }

      if (to) {
        const normalizedTo = new Date(to);
        normalizedTo.setHours(23, 59, 59, 999);
        if (requestDate > normalizedTo) {
          return false;
        }
      }

      return true;
    };

    const includesSearchValue = (request) => {
      if (!normalizedSearch) {
        return true;
      }

      const searchInValue = (value) => {
        if (value === null || value === undefined) {
          return false;
        }

        if (typeof value === 'object') {
          return Object.values(value).some((nested) => searchInValue(nested));
        }

        return String(value).toLowerCase().includes(normalizedSearch);
      };

      return Object.values(request).some(searchInValue);
    };

    const filtered = allRequests.filter((request) => filterByDate(request) && includesSearchValue(request));

    const totalRecords = filtered.length;
    const totalPages = totalRecords > 0 ? Math.ceil(totalRecords / filters.pageSize) : 0;
    const lastPageIndex = Math.max(totalPages - 1, 0);
    const currentPage = Math.min(Math.max(filters.pageNumber, 0), lastPageIndex);
    const startIndex = currentPage * filters.pageSize;
    const pageSlice = filtered.slice(startIndex, startIndex + filters.pageSize);

    setRequestsData(pageSlice);
    setMeta({
      totalRecords,
      totalPages,
      currentPage,
      pageSize: filters.pageSize,
    });

    if (currentPage !== filters.pageNumber) {
      setFilters((prev) => ({ ...prev, pageNumber: currentPage }));
    }
  }, [allRequests, filters]);

  const handleDateChange = (key, value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      pageNumber: 0,
    }));
  };

  const handleSearch = (value) => {
    setFilters((prev) => ({
      ...prev,
      searchValue: value,
      pageNumber: 0,
    }));
  };

  const handleTableDataChange = (updatedPageData = []) => {
    if (!Array.isArray(updatedPageData)) {
      return;
    }

    setAllRequests((prev) => {
      const next = [...prev];
      const indexById = new Map(next.map((item, index) => [item.id, index]));

      updatedPageData.forEach((item) => {
        if (!item || !item.id) {
          return;
        }

        if (indexById.has(item.id)) {
          const idx = indexById.get(item.id);
          next[idx] = { ...next[idx], ...item };
        } else {
          next.unshift(item);
        }
      });

      return next;
    });
  };

  const handlePageChange = (pageNumber) => {
    setFilters((prev) => ({
      ...prev,
      pageNumber,
    }));
  };

  const handlePageSizeChange = (pageSize) => {
    setFilters((prev) => ({
      ...prev,
      pageSize,
      pageNumber: 0,
    }));
  };

  return (
    <Container fluid>
      <TopUpRequestTable
        data={requestsData}
        loading={false}
        pagination={{
          totalRecords: meta.totalRecords,
          pageSize: filters.pageSize,
          currentPage: meta.currentPage,
          totalPages: meta.totalPages,
        }}
        onDataChange={handleTableDataChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        searchValue={filters.searchValue}
        onSearch={handleSearch}
        fromDate={filters.fromDate}
        toDate={filters.toDate}
        onDateChange={handleDateChange}
        allowCreateButton={false}
        denseRows={true}
      />
    </Container>
  );
};

export default TopUpRequestFromRetailer;

